import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'aa-os-picture',
    templateUrl: './os-picture.component.html',
    styleUrls: [
        './os-picture.component.scss'
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class OsPictureComponent
{
    @Input() title: string = 'Operating System';
    @Input() location: string;
    @Input() size: number = 48;
}
